import { useEffect, useRef, useState } from "react";
import { createSatuanPrestasiRequest } from "../../../../api/SatuanPrestasiRequest";
import { Button, InputArea, InputFile, InputNumber, InputSelectDropDown, InputText } from "../../../../components";

const AddPrestasiSatuanV2Modal = (props) => {
    const ref = useRef();
    const [isShow, setIsShow] = useState(false);
    const [controller, setController] = useState({});
    const [errors, setErrors] = useState({});

    const toogleModal = () => {
        setIsShow(!isShow);
    };

    const handleClickOutside = (event) => {
        if (!ref?.current?.contains(event.target)) {
            setIsShow(false);
        }
    };

    const onSetController = (field, value) => {
        setController({ ...controller, [field]: value });
    };

    const onSave = async () => {
        let dataBatch = { ...controller };
        dataBatch.satuan_id = props.satuan.id;
        dataBatch.gambar = dataBatch.picture?.file ?? null;
        dataBatch.bidang = dataBatch.bidang?.key;
        dataBatch.kategori = 'satuan';
        await createSatuanPrestasiRequest({ body: dataBatch }).then((res) => {
            res?.errors && setErrors(res?.errors);
            if (!res?.errors) {
                setController({});
                setErrors({});
                toogleModal();
                props.onSave && props.onSave();
            }
        });
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="inline-block" ref={ref}>
            <div className="cursor-pointer" onClick={() => toogleModal()}>
                <div className="flex gap-3 items-center text-slate-600">
                    <Button className="bg-red-800 text-white flex justify-center py-[0.4rem] pl-3">
                        <svg  xmlns="http://www.w3.org/2000/svg" className="text-white"  width="16"  height="16"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 5l0 14" /><path d="M5 12l14 0" /></svg>
                        Satuan
                    </Button>
                </div>
            </div>
            <div className={`fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center z-10 ${!isShow && "hidden"}`}>
                <div className="absolute w-full h-full bg-black opacity-30 z-10" onClick={() => toogleModal()}></div>
                <div className="p-3 border rounded-lg bg-white w-96 max-h-screen overflow-y-auto z-10">
                    <div className="leading-3">
                        <span className="text-base font-medium">Tambah Data Prestasi</span>
                        <br />
                        <small>Silahkan isi form data prestasi</small>
                    </div>
                    <div className="min-h-[25vh] flex flex-col gap-1 py-2 my-2">
                        <div className="flex justify-center">
                            <div className="w-40 h-40 relative">
                                {controller?.picture?.preview && (<div className="w-full h-full absolute bg-slate-100">
                                    <img src={controller?.picture?.preview} alt="ImageProfile" className="object-cover w-full h-full" />
                                </div>)}
                                <div className="flex justify-center items-center h-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="text-slate-300" width="100" height="100" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M15 8h.01" /><path d="M6 13l2.644 -2.644a1.21 1.21 0 0 1 1.712 0l3.644 3.644" /><path d="M13 13l1.644 -1.644a1.21 1.21 0 0 1 1.712 0l1.644 1.644" /><path d="M4 8v-2a2 2 0 0 1 2 -2h2" /><path d="M4 16v2a2 2 0 0 0 2 2h2" /><path d="M16 4h2a2 2 0 0 1 2 2v2" /><path d="M16 20h2a2 2 0 0 0 2 -2v-2" /></svg>
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-center my-4">
                            <InputFile error={errors.picture} onChange={(value) => onSetController('picture', value)} />
                        </div>
                        <div>
                            <span className="font-medium">Nama</span>
                            <InputText className="mt-1" value={controller.title} error={errors.title} onChange={(value) => onSetController("title", value)} placeholder="..." />
                        </div>
                        <div>
                            <div className="flex flex-col">
                                <span className="font-medium">Bidang</span>
                                <small>Bidang wajib diisi</small>
                            </div>
                            <InputSelectDropDown className="mt-1" data={[{ title: 'Tugas Operasi', key: 'Tugas Operasi' }, { title: 'Olahraga', key: 'Olahraga' }]} value={controller.bidang?.title} error={errors.bidang} onChange={(value) => onSetController("bidang", value)} placeholder="Pilih Bidang" />
                        </div>
                        <div>
                            <span className="font-medium">Prestasi</span>
                            <InputArea className="mt-1" value={controller.deskripsi} error={errors.deskripsi} onChange={(value) => onSetController("deskripsi", value)} placeholder="..." />
                        </div>
                        <div>
                            <span className="font-medium">Tahun</span>
                            <InputNumber className="mt-1" value={controller.tahun} error={errors.tahun} onChange={(value) => onSetController("tahun", value)} placeholder="..." />
                        </div>
                        <div className="flex-grow" />
                        <div className="flex justify-end mt-3">
                            <Button className="bg-slate-700 text-white" onClick={() => onSave()}>
                                Simpan
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddPrestasiSatuanV2Modal;
